// @flow
import moment from "moment";

export const Validator = {
  // generic validators
  dob: (val: string): boolean => {
    if (!val) return false;
    return isValidDate(val);
  },
  email: (val: string): boolean => {
    if (!val) return false;
    return emailRegex.test(val);
  },
  uk_phone_number: (val: string): boolean => {
    if (!val) return false;
    return ukPhoneRegex.test(val);
  },
  address: (val: string): boolean => {
    if (!val) return false;
    return val.length > 10;
  },
  postcode: (val: string): boolean => {
    if (!val) return false;
    return postcodeRegex.test(val);
  },
  anytext: (val: string): boolean => {
    if (!val) return false;
    return val.length > 1;
  },
  multi_choice: (val: string): boolean => {
    if (!val || val === "" || val === "none") return false;
    return true;
  },
  // specific validators
  misctext: (val: string): boolean => {
    if (!val) return false;
    return val.length > 1;
  },
  agent_name: (val: string): boolean => {
    return Validator.misctext(val);
  },

  agent_contact_number: (val: string): boolean => {
    if (!val) return false;
    return ukPhoneRegex.test(val);
  },
  agent_contact_email: (val: string): boolean => {
    if (!val) return false;
    return emailRegex.test(val);
  },

  venue_name: (val: string): boolean => {
    return Validator.misctext(val);
  },

  venue_address: (val: string): boolean => {
    if (!val) return false;
    return val.length > 10;
  },

  venue_postcode: (val: string): boolean => {
    if (!val) return false;

    return postcodeRegex.test(val);
  },

  venue_contact_name: (val: string): boolean => {
    return Validator.misctext(val);
  },

  venue_contact_number: (val: string): boolean => {
    if (!val) return false;
    return ukPhoneRegex.test(val);
  },

  venue_contact_email: (val: string): boolean => {
    if (!val) return false;

    return emailRegex.test(val.toLowerCase());
  },

  event_type: (val: string): boolean => {
    return Validator.misctext(val);
  },

  event_date: (val: string): boolean => {
    if (!val) return false;
    return isValidDate(val);
  },

  event_start_time: (val: string): boolean => {
    return isValidTime(val);
  },

  event_finish_time: (val: string): boolean => {
    return isValidTime(val);
  },

  customer_name: (val: string): boolean => {
    return Validator.misctext(val);
  },

  customer_contact_number: (val: string): boolean => {
    if (!val) return false;
    return ukPhoneRegex.test(val);
  },

  customer_contact_email: (val: string): boolean => {
    if (!val) return false;

    return emailRegex.test(val.toLowerCase());
  },

  event_guestcount: (val: number): boolean => {
    return val > 0;
  },

  loadin_time: (val: string): boolean => {
    return isValidTime(val);
  },

  loadin_finish: (val: string): boolean => {
    return isValidTime(val);
  },

  loadout_time: (val: string): boolean => {
    return isValidTime(val);
  },

  package_type: (val: string): boolean => {
    if (!val || val === "" || val === "none") return false;
    return true;
  },

  // comments:(val:string)=>{return true}
};

const postcodeRegex = RegExp(
  /^(([gG][iI][rR] {0,}0[aA]{2})|((([a-pr-uwyzA-PR-UWYZ][a-hk-yA-HK-Y]?[0-9][0-9]?)|(([a-pr-uwyzA-PR-UWYZ][0-9][a-hjkstuwA-HJKSTUW])|([a-pr-uwyzA-PR-UWYZ][a-hk-yA-HK-Y][0-9][abehmnprv-yABEHMNPRV-Y]))) {0,}[0-9][abd-hjlnp-uw-zABD-HJLNP-UW-Z]{2}))$/
);
const ukPhoneRegex = RegExp(/^(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?#(\d{4}|\d{3}))?$/);
const emailRegex = RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
const timeRegex = RegExp(/^([0-9]|0[0-9]|1[0-9]|2[0-3])[.|:|-]?[0-5][0-9]$/);

function isValidDate(d) {
  var pattern = /([0-2]\d{1}|3[0-1])\/(0\d{1}|1[0-2])\/(19|20)?(\d{2})/;

  var m = d.match(pattern);
  if (!m) {
    // console.log("no match:", d);
    return false;
  }

  const d1 = moment(d, "DD/MM/YYYY");
  const d2 = moment(d, "DD/MM/YY");

  if (d1.isValid() === false && d2.isValid() === false) {
    // console.log("no match-2:", d, d1, d2);
    return false;
  } else {
    // console.log("match", d)
    return true;
  }
}

function isValidTime(val: string) {
  // console.log(val)
  if (!val) return false;
  // console.log(timeRegex.test(val))
  return timeRegex.test(val);
}
